<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import SidenavList from "./SidenavList.vue";
import logo from "@/assets/img/1.png";
import logoWhite from "@/assets/img/logo-financas-branco-transparente.png";

const store = useStore();
const isRTL = computed(() => store.state.isRTL);
const layout = computed(() => store.state.layout);
const sidebarType = computed(() => store.state.sidebarType);
const darkMode = computed(() => store.state.darkMode);
</script>
<template>
  <div
    v-show="layout === 'default'"
    class="position-absolute w-100 z-index-3"
    :class="`${darkMode ? 'bg-transparent' : ''}`"
  />

  <aside
    class="my-3 overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs border-radius-xl fixed-side-menu"
    :class="`${isRTL ? 'me-3 rotate-caret fixed-end' : 'fixed-start ms-3'}    
      ${
        layout === 'landing' ? 'bg-transparent shadow-none' : ' '
      } ${sidebarType}`"
    id="sidenav-main"
  >
    <div class="sidenav-header">
      <i
        class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true"
        id="iconSidenav"
      ></i>

      <router-link class="m-0" to="/">
        <img
          :src="darkMode || sidebarType === 'bg-default' ? logoWhite : logo"
          class="logo-sidebar"
          alt="main_logo"
        />
      </router-link>
    </div>

    <hr class="mt-0 horizontal dark" />

    <sidenav-list />
  </aside>
</template>

<style>
  .fixed-side-menu{
      left: 0;
  }

  .bg-041b23{
      background-color: #041b23;
    }

  .logo-sidebar{
    width: 60%;
    height: auto;
    margin-top: 0%;
    margin-left: 19%;
  }

  .navbar-vertical.bg-white .navbar-nav > .nav-item .nav-link.active {
      background-color: #e6e9eb !important;
      color: #d18536 !important;
  }
  

  @media (max-width: 1050px) {

    .fixed-side-menu{
        left: auto !important;
        right: 10px !important;
    }

    .navbar-vertical.navbar-expand-xs{
      bottom: 11% !important;
    }

    .g-sidenav-show:not(.rtl) .sidenav {
      transform: translateX(17.125rem) !important;
    }

    .g-sidenav-show.g-sidenav-pinned .sidenav{
      transform: translateX(0) !important;
    }

  }


</style>
